import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import config from 'src/configs/config';

let appInsights: ApplicationInsights | null = null;

if (!config.tabAppInsightsConnection) {
  // eslint-disable-next-line no-console
  console.warn('Application Insights connection string is not set');
}
else {
  appInsights = new ApplicationInsights({
    config: {
      connectionString: config.tabAppInsightsConnection,
      disableExceptionTracking: true,
      enableAutoRouteTracking: true,
    },
  });

  appInsights.loadAppInsights();
}

export { appInsights };
